module.exports = __webpack_public_path__ + "media/soar_home.1572da30.mp4";